import axios from 'axios';

import csrfHeaders from '../../utils/csrfHeaders';

export const replyFaxDestinationUrl = (sendToken) => (
  `/api/v1/receivers/${sendToken}/reply_fax_destination`
);

// Window event fired after a reply number is saved, so every surface showing
// that referral's reply number (viewer header, list chip) refreshes.
export const REPLY_FAX_DESTINATION_CHANGED = 'reply-fax-destination-changed';

// The referral's reply fax destination, or null while the org does not have
// `referral_reply_fax_approval` (the endpoint answers enabled: false).
export const fetchReplyFaxDestination = async (sendToken) => {
  const { data } = await axios.get(replyFaxDestinationUrl(sendToken));
  return data?.enabled === true ? data : null;
};

export const saveReplyFaxNumber = async (sendToken, { scope, faxNumber }) => {
  const { data } = await axios.post(
    replyFaxDestinationUrl(sendToken),
    { scope, fax_number: faxNumber },
    { headers: csrfHeaders() },
  );
  window.dispatchEvent(new CustomEvent(REPLY_FAX_DESTINATION_CHANGED, { detail: { sendToken } }));
  return data;
};

// Choice options: the number the fax states, or the line's current reply
// number (an admin's override, else the line the fax came from).
export const DOCUMENT_OPTION = 'document';
export const LINE_OPTION = 'line';

export const currentNumber = (destination) => (
  destination?.current_destination || destination?.sender_fax_number || null
);

// Remembering is offered only for the number the fax states: it saves that
// number for every fax from the same line that states it again.
export const canRemember = (destination) => Boolean(
  destination?.extracted_number
  && destination?.sender_fax_number
  && destination?.allowed_scopes?.includes('sender'),
);

// Nothing chosen. Update Referral starts here because it saves the choice
// as part of the status change: an untouched choice must not approve a
// number, and remembering it for the line is always an explicit tick.
export const UNCHOSEN_REPLY_CHOICE = { option: null, remember: false };

// The choice the reply number dialog starts from, saved only by its own Save
// button: the number on the fax, for this referral only until they tick remember.
export const defaultReplyChoice = (destination) => {
  if (destination?.extracted_number) {
    return { option: DOCUMENT_OPTION, remember: false };
  }
  if (currentNumber(destination)) return { option: LINE_OPTION, remember: false };
  return { option: null, remember: false };
};

// What to POST for a choice, or null when nothing is chosen.
export const replyChoiceRequest = (destination, choice) => {
  if (choice?.option === DOCUMENT_OPTION && destination?.extracted_number) {
    return {
      scope: choice.remember && canRemember(destination) ? 'sender' : 'referral',
      faxNumber: destination.extracted_number,
    };
  }
  if (choice?.option === LINE_OPTION && currentNumber(destination)) {
    return { scope: 'referral', faxNumber: currentNumber(destination) };
  }
  return null;
};
